import {
	Box,
	ChakraProvider,
	FormControl,
	FormLabel,
	Portal,
	Switch,
	Text,
} from "@chakra-ui/react";
// @ts-ignore
import { select } from "@wordpress/data";
import { PluginSidebar } from "@wordpress/edit-post";
import { __ } from "@wordpress/i18n";
import React, { useState } from "react";
import theme from "../../theme/theme";
import Colors from "./Colors";
import "./editor.scss";
import StyleGuidePreview from "./StyleGuidePreview";
import Typographies from "./Typographies";
import Categories from "./Categories";

const Plugin = () => {
	const [isStylePreviewGuideOpen, setIsStylePreviewGuideOpen] =
		useState(false);
	const containerRef = React.useRef<any>(null);
	const activeArea =
		select("core/interface").getActiveComplementaryArea("core/edit-post");
	React.useEffect(() => {
		containerRef.current = document.querySelector(
			".interface-interface-skeleton__content"
		) as HTMLDivElement;
	}, []);

	const toggleBodyClass = (add = false) => {
		const action = add ? "add" : "remove";
		document.body.classList[action]("mzb-style-guide--open");
	};

	React.useEffect(() => {
		const isMagazineBlocksAreaOpen =
			"magazine-blocks/magazine-blocks-plugin-sidebar" === activeArea;
		if (!isMagazineBlocksAreaOpen) {
			setIsStylePreviewGuideOpen(false);
			return;
		}
		toggleBodyClass(isStylePreviewGuideOpen && isMagazineBlocksAreaOpen);
		return () => {
			document.body?.classList.remove("mzb-style-guide--open");
		};
	}, [isStylePreviewGuideOpen, activeArea]);

	return (
		<PluginSidebar
			name="magazine-blocks-plugin-sidebar"
			title={__("Magazine Blocks", "magazine-blocks")}
			icon={
				<svg
					width={20}
					height={20}
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24"
					className="magazine-blocks-sidebar-global-styles-button"
				>
					<path
						d="M20.7431 20.9268H4.80029V4.92676H20.7431V20.9268ZM5.52132 20.2057H20.0335V5.64779H5.52132V20.2057Z"
						fill="#8D42CE"
					></path>
					<path
						d="M12.935 18.2749H7.29542V7.91742L12.935 11.4385V18.2749Z"
						fill="#8D42CE"
					></path>
					<path
						d="M18.5626 18.2749H12.935V11.4385L18.5626 7.91742V18.2749Z"
						fill="#690AA0"
					></path>
				</svg>
			}
		>
			<ChakraProvider theme={theme} cssVarsRoot=".magazine-blocks">
				<div className="magazine-blocks">
					<Box px="18px" py="14px">
						<FormControl
							display="flex"
							justifyContent="space-between"
							alignItems="center"
							mb="18px"
						>
							<FormLabel fontSize="13px" fontWeight="semibold">
								{__("Style Preview Guide", "magazine-blocks")}
							</FormLabel>
							<Switch
								isChecked={isStylePreviewGuideOpen}
								onChange={(e) => {
									setIsStylePreviewGuideOpen(
										e.target.checked
									);
								}}
							/>
						</FormControl>
						<Text
							as="span"
							fontSize="12px"
							fontStyle="italic"
							color="gray.600"
						>
							{__(
								"Switch between the content area and style guide to preview your changes to global stiles",
								"magazine-blocks"
							)}
						</Text>
					</Box>
					<Colors />
					<Typographies />
					<Categories />
					{isStylePreviewGuideOpen && containerRef.current && (
						<Portal containerRef={containerRef}>
							<StyleGuidePreview />
						</Portal>
					)}
				</div>
			</ChakraProvider>
		</PluginSidebar>
	);
};

export default Plugin;
